import { render, staticRenderFns } from "./CampoDePercentual.vue?vue&type=template&id=1819ec1f&"
import script from "./CampoDePercentual.vue?vue&type=script&lang=ts&"
export * from "./CampoDePercentual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports